import { generatePlatformMenuRoutes } from "../constants/constants";
import MenuItemCustom from "./MenuItemCustom";
import { GetImages } from "../utils/GetImages";
import { useMenu } from "../utils/context/MenuContext";
import "./CustomMenuStyles.css";

/**
 * Left rail for the platform super-admin "Platform Settings" sub-shell (Payment Accounts, Support Requests,
 * Organizations — from `generatePlatformMenuRoutes`), shown when the path is under /platform-settings. The main
 * platform portal nav is the reused organization `CustomMenu`; this rail only appears inside Platform Settings.
 * NO permission filtering — a Platform JWT carries no per-module permission map, so gating is done purely by the
 * App.tsx Platform role branch.
 */
const PlatformMenu = ({ size }: { size: number }) => {
  const { isOpen, setIsOpen, setIsHidden } = useMenu();
  const menuRoutes = generatePlatformMenuRoutes();

  return (
    <div className="sidebarMenuContainer pb-2">
      <div
        className="sidebarToggleCenter mainBackground"
        onClick={() => {
          if (size < 400) {
            setIsHidden(true);
            setIsOpen(!isOpen);
          } else {
            setIsOpen(!isOpen);
          }
        }}
      >
        <img
          src={isOpen ? GetImages.BlackChevronLeft : GetImages.BlackChevronRight}
          alt="toggle"
        />
      </div>

      <div className="sidebarMenu">
        <div
          className={isOpen ? "normalClass BorderTop" : "collapsedBarClass BorderTopHide"}
          data-title={!isOpen ? "Dashboard" : ""}
        >
          <MenuItemCustom
            primaryText="Dashboard"
            to="/"
            key={"platform-menu-dashboard"}
            className={
              location.pathname === "/"
                ? "menuItemLinkClassSelected normal_text"
                : "menuItemLinkClass normal_text"
            }
            isSelected={location.pathname === "/"}
            leftIcon={GetImages.dashboardIcon}
            alt="Dashboard Icon"
          />
        </div>

        <div className={isOpen ? "BorderTop" : "BorderTopHide"}>
          <p
            className="sub_text accountHeading"
            style={{ display: isOpen ? "block" : "none" }}
          >
            Platform Settings
          </p>
          {menuRoutes?.map((value, index) => {
            const isSelected = location.pathname.includes(value.path);
            return (
              <div
                key={index}
                className={isOpen ? "normalClass" : "collapsedBarClass"}
                data-title={!isOpen ? value.primaryText : ""}
              >
                <MenuItemCustom
                  to={value.path}
                  primaryText={value.primaryText}
                  leftIcon={!isSelected ? value.leftIcon : value.selectedIcon}
                  className={
                    isSelected
                      ? "menuItemLinkClassSelected normal_text"
                      : "menuItemLinkClass normal_text"
                  }
                  isSelected={isSelected}
                  alt={value.primaryText}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PlatformMenu;
